import { observer } from 'mobx-react-lite'
import List from '@mui/material/List'
import Box from '@mui/system/Box'
import { useMainContainerStore } from '../MainContainerStore'
import Typography from '@mui/material/Typography'
import { useNotificationsStore } from './NotificationsStore'
import Notification from './Notification'
import Button from '@mui/material/Button'
import DoneAllIcon from '@mui/icons-material/DoneAllOutlined'
import { useThemeStore } from 'theme/ThemeStore'
import Divider from '@mui/material/Divider'
import Popover from '@mui/material/Popover'
import { themeConfig }from '@gap/shared/theme'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'

export default observer(function Notifications() {
   const mainContainerStore = useMainContainerStore()
   const notificationsStore = useNotificationsStore()
   const themeStore = useThemeStore()

   return <Popover
      sx={{
         '& .MuiPaper-root': {
            width: '420px',
            maxHeight: '600px',
            minHeight: '220px',
            borderRadius: 2,
            mt: 5,
            ml: 10
         },
         '& .MuiAccordion-root': {
            width: '100%'
         },
      }}
      open={mainContainerStore.notificationsState.visible}
      onClose={mainContainerStore.notificationsState.close}
      anchorOrigin={{
         vertical: 'top',
         horizontal: 'right',
      }}
      transformOrigin={{
         vertical: 'top',
         horizontal: 'right',
      }}
      anchorEl={notificationsStore.notificationToggleRef.current}>
      <Box sx={{ overflowX: 'hidden', height: '100%' }}>
         <Box sx={{ position: 'sticky', top: 0, pt: 2, bgcolor: 'background.paper', zIndex: themeStore.theme.zIndex.appBar }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
               <Typography variant='subtitle2Bold' sx={{ pl: 3, color: themeConfig.primary[600] }}>Notifications</Typography>
               <Button sx={{ mr: 2 }} disabled={notificationsStore.unreadNotificationCount === 0} startIcon={<DoneAllIcon />} onClick={notificationsStore.markAllAsRead}>Mark all as read</Button>
            </Box>
            <Box sx={{ pl: 3, mr: 2 }}>
               <Tabs value={notificationsStore.showOnlyUnread ? 1 : 0} onChange={notificationsStore.toggleShowUnread}>
                  <Tab label="All" sx={{ textTransform: "none", minWidth: '10px', p: 1 }} />
                  <Tab label="Unread" sx={{ textTransform: "none", minWidth: '10px', p: 1 }} />
               </Tabs>
            </Box>
            <Divider />
         </Box>
         <Box>
            <List sx={{ width: '100%', maxWidth: '100%', py: 0 }}>
               {notificationsStore.filteredNotifications.map(notification => <Box key={notification.id}>
                  <Notification notification={notification} />
                  <Divider component="li" />
               </Box>)}
            </List>
            {!notificationsStore.filteredNotifications.length &&
               <Box sx={{ display: 'flex', justifyContent: 'center', pt: 6 }}>
                  {notificationsStore.showOnlyUnread && 'You have no unread notifications'}
                  {!notificationsStore.showOnlyUnread && 'You have no notifications'}
               </Box>
            }
         </Box>
      </Box>
   </Popover>
})
